// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppBannerController from "./app_banner_controller"
application.register("app-banner", AppBannerController)

import BricksCardSubscriptionController from "./bricks_card_subscription_controller"
application.register("bricks-card-subscription", BricksCardSubscriptionController)

import Bridge__AuthenticationController from "./bridge/authentication_controller"
application.register("bridge--authentication", Bridge__AuthenticationController)

import Bridge__ButtonController from "./bridge/button_controller"
application.register("bridge--button", Bridge__ButtonController)

import Bridge__CartButtonController from "./bridge/cart_button_controller"
application.register("bridge--cart-button", Bridge__CartButtonController)

import Bridge__LocationController from "./bridge/location_controller"
application.register("bridge--location", Bridge__LocationController)

import Bridge__MenuController from "./bridge/menu_controller"
application.register("bridge--menu", Bridge__MenuController)

import Bridge__NavActionsController from "./bridge/nav_actions_controller"
application.register("bridge--nav-actions", Bridge__NavActionsController)

import Bridge__SearchController from "./bridge/search_controller"
application.register("bridge--search", Bridge__SearchController)

import Bridge__NotificationTokenController from "./bridge/notification_token_controller"
application.register("bridge--notification-token", Bridge__NotificationTokenController)

import Bridge__NotificationBadgeController from "./bridge/notification_badge_controller"
application.register("bridge--notification-badge", Bridge__NotificationBadgeController)

import Bridge__ShareController from "./bridge/share_controller"
application.register("bridge--share", Bridge__ShareController)

import Bridge__StoreHeaderController from "./bridge/store_header_controller"
application.register("bridge--store-header", Bridge__StoreHeaderController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CarouselLoaderController from "./carousel_loader_controller"
application.register("carousel-loader", CarouselLoaderController)

import CartController from "./cart_controller"
application.register("cart", CartController)

import ChatMessageController from "./chat_message_controller"
application.register("chat-message", ChatMessageController)

import ChatPartnerController from "./chat_partner_controller"
application.register("chat-partner", ChatPartnerController)

import ChipLimitController from "./chip_limit_controller"
application.register("chip-limit", ChipLimitController)

import ChoiceSheetController from "./choice_sheet_controller"
application.register("choice-sheet", ChoiceSheetController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CommissionCalculatorController from "./commission_calculator_controller"
application.register("commission-calculator", CommissionCalculatorController)

import CreditPackBrickController from "./credit_pack_brick_controller"
application.register("credit-pack-brick", CreditPackBrickController)

import CreditPackStatusController from "./credit_pack_status_controller"
application.register("credit-pack-status", CreditPackStatusController)

import CustomerPreviewController from "./customer_preview_controller"
application.register("customer-preview", CustomerPreviewController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DraftNoticeController from "./draft_notice_controller"
application.register("draft-notice", DraftNoticeController)

import DeliveryAddressController from "./delivery_address_controller"
application.register("delivery-address", DeliveryAddressController)

import DeliveryPriceDialogController from "./delivery_price_dialog_controller"
application.register("delivery-price-dialog", DeliveryPriceDialogController)

import DeliveryTipController from "./delivery_tip_controller"
application.register("delivery-tip", DeliveryTipController)

import DiscountFormController from "./discount_form_controller"
application.register("discount-form", DiscountFormController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormStoreController from "./form_store_controller"
application.register("form-store", FormStoreController)

import IngredientLimitController from "./ingredient_limit_controller"
application.register("ingredient-limit", IngredientLimitController)

import IngredientQtyController from "./ingredient_qty_controller"
application.register("ingredient-qty", IngredientQtyController)

import InstallPwaController from "./install_pwa_controller"
application.register("install-pwa", InstallPwaController)

import LiveSearchController from "./live_search_controller"
application.register("live-search", LiveSearchController)

import LocationController from "./location_controller"
application.register("location", LocationController)

import MapController from "./map_controller"
application.register("map", MapController)

import MenuToggleController from "./menu_toggle_controller"
application.register("menu-toggle", MenuToggleController)

import MessageActionsController from "./message_actions_controller"
application.register("message-actions", MessageActionsController)

import NotificationListController from "./notification_list_controller"
application.register("notification-list", NotificationListController)

import OrderActionsController from "./order_actions_controller"
application.register("order-actions", OrderActionsController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import OtpResendCountdownController from "./otp_resend_countdown_controller"
application.register("otp-resend-countdown", OtpResendCountdownController)

import PhonePromptController from "./phone_prompt_controller"
application.register("phone-prompt", PhonePromptController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PickupController from "./pickup_controller"
application.register("pickup", PickupController)

import PlacesController from "./places_controller"
application.register("places", PlacesController)

import MoneyInputController from "./money_input_controller"
application.register("money-input", MoneyInputController)

import PhotoFieldController from "./photo_field_controller"
application.register("photo-field", PhotoFieldController)

import PhotoListController from "./photo_list_controller"
application.register("photo-list", PhotoListController)

import UploadLockController from "./upload_lock_controller"
application.register("upload-lock", UploadLockController)

import ProductArchiveController from "./product_archive_controller"
application.register("product-archive", ProductArchiveController)

import ProductDraftController from "./product_draft_controller"
application.register("product-draft", ProductDraftController)

import ProductRestoreController from "./product_restore_controller"
application.register("product-restore", ProductRestoreController)

import ProductFormController from "./product_form_controller"
application.register("product-form", ProductFormController)

import ProductRowController from "./product_row_controller"
application.register("product-row", ProductRowController)

import ProductOptionsController from "./product_options_controller"
application.register("product-options", ProductOptionsController)

import ProductWizardController from "./product_wizard_controller"
application.register("product-wizard", ProductWizardController)

import ReviewSummaryController from "./review_summary_controller"
application.register("review-summary", ReviewSummaryController)

import RangeCalendarController from "./range_calendar_controller"
application.register("range-calendar", RangeCalendarController)

import SectionChipsController from "./section_chips_controller"
application.register("section-chips", SectionChipsController)

import SectionPhotosController from "./section_photos_controller"
application.register("section-photos", SectionPhotosController)

import AppUpdateController from "./app_update_controller"
application.register("app-update", AppUpdateController)

import SectionRowController from "./section_row_controller"
application.register("section-row", SectionRowController)

import SectionSheetController from "./section_sheet_controller"
application.register("section-sheet", SectionSheetController)

import SectionLayoutSheetController from "./section_layout_sheet_controller"
application.register("section-layout-sheet", SectionLayoutSheetController)

import CartQuantitiesController from "./cart_quantities_controller"
application.register("cart-quantities", CartQuantitiesController)

import QuickAddController from "./quick_add_controller"
application.register("quick-add", QuickAddController)

import SectionsListController from "./sections_list_controller"
application.register("sections-list", SectionsListController)

import StepperController from "./stepper_controller"
application.register("stepper", StepperController)

import StoreLazyController from "./store_lazy_controller"
application.register("store-lazy", StoreLazyController)

import StoreSearchController from "./store_search_controller"
application.register("store-search", StoreSearchController)

import StockFieldController from "./stock_field_controller"
application.register("stock-field", StockFieldController)

import ProductsCatalogController from "./products_catalog_controller"
application.register("products-catalog", ProductsCatalogController)

import ReasoningController from "./reasoning_controller"
application.register("reasoning", ReasoningController)

import RefundItemsController from "./refund_items_controller"
application.register("refund-items", RefundItemsController)

import RequirementStatusController from "./requirement_status_controller"
application.register("requirement-status", RequirementStatusController)

import ScrollHeaderController from "./scroll_header_controller"
application.register("scroll-header", ScrollHeaderController)

import StepsController from "./steps_controller"
application.register("steps", StepsController)

import StorePhoneModalController from "./store_phone_modal_controller"
application.register("store-phone-modal", StorePhoneModalController)

import StickyNavController from "./sticky_nav_controller"
application.register("sticky-nav", StickyNavController)

import StoreFiltersController from "./store_filters_controller"
application.register("store-filters", StoreFiltersController)

import StoreImageController from "./store_image_controller"
application.register("store-image", StoreImageController)

import StoreScheduleController from "./store_schedule_controller"
application.register("store-schedule", StoreScheduleController)

import SupportChatController from "./support_chat_controller"
application.register("support-chat", SupportChatController)

import SwipeRowController from "./swipe_row_controller"
application.register("swipe-row", SwipeRowController)

import TabbarController from "./tabbar_controller"
application.register("tabbar", TabbarController)

import TimerDiscountController from "./timer_discount_controller"
application.register("timer-discount", TimerDiscountController)

import ValidationPresentialController from "./validation_presential_controller"
application.register("validation-presential", ValidationPresentialController)

import VideoModalController from "./video_modal_controller"
application.register("video-modal", VideoModalController)

import ClampController from "./clamp_controller"
application.register("clamp", ClampController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)
